import { FILTER_TYPES } from 'components/FilterPod';
import {
  SUBSCRIPTION_TYPES,
  PERIOD_TYPES,
} from '../../constants/SubscriptionConstants';

const filters = (currencyText) => [
 
  {
    title: 'نوع طرح اشتراک',
    label: 'نوع طرح',
    keyName: 'typeCode',
    id: 1664,
    value: null,
    filterType: FILTER_TYPES.select,
    filterProps: {
      options: [...SUBSCRIPTION_TYPES],
    },
  },
  {
    title: 'شناسه محصول',
    label: 'شناسه محصول',
    keyName: 'permittedProductId',
    id: 1664,
    value: null,
    filterType: FILTER_TYPES.text,
  },
  {
    title: 'محدوده‌ مبلغ مورد نظر',
    label: {
      start: 'از مبلغ',
      end: 'تا مبلغ',
    },
    keyName: 'priceRange',
    unit: 'ریال',
    id: {
      start: 'fromPrice',
      end: 'toPrice',
    },
    query: {
      start: 'fromPrice',
      end: 'toPrice',
    },
    value: {
      start: null,
      end: null,
    },
    filterType: FILTER_TYPES.textRange,
    filterProps: {
      start: {
        currency: true,
        decimalPlaces: 0,
        minimumValue: 0,
      },
      end: {
        currency: true,
        decimalPlaces: 0,
        minimumValue: 0,
      },
    },
    getValueLabel: (v) => `${v} ${currencyText} `,
  },
  {
    title: 'نوع مصرف',
    label: 'نوع مصرف',
    keyName: 'oneTimeUse',
    id: 1649,
    value: null,
    filterType: FILTER_TYPES.select,
    filterProps: {
      options: [
        {
          value: true,
          label: 'یک بار مصرف',
        },
        {
          value: false,
          label: 'چند بار مصرف',
        },
      ],
    },
  },
  {
    title: 'نوع دوره',
    label: 'نوع دوره',
    keyName: 'periodTypeCode',
    id: 1664,
    value: null,
    filterType: FILTER_TYPES.select,
    filterProps: {
      options: [...PERIOD_TYPES],
    },
  },
  {
    title: 'محدوده تعداد دوره',
    label: {
      start: 'از',
      end: 'تا',
    },
    keyName: 'periodTypeCountRange',
    id: {
      start: 'periodTypeCountFrom',
      end: 'periodTypeCountTo',
    },
    query: {
      start: 'periodTypeCountFrom',
      end: 'periodTypeCountTo',
    },
    value: {
      start: null,
      end: null,
    },
    filterType: FILTER_TYPES.textRange,
    filterProps: {
      start: {},
      end: {},
    },
  },

];

export default filters;
